import trae from 'trae'
import configService  from './config'

const wpOcService = trae.create({
    baseUrl: configService.apiUrl
})

export default wpOcService


// WEBPACK FOOTER //
// ./src/ws/wp-oc-service.js